import PhotovoltaicGenerators from "../classes/PhotovoltaicGenerator"

export const photovoltaicGenerators = [
  new PhotovoltaicGenerators({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new PhotovoltaicGenerators({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new PhotovoltaicGenerators({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
